import { useEffect, useState } from 'react'
import { serverUrl } from '../../../utilites/config'
import { type RfiMeasurement } from '../components/InterferenceMap/rfiScan'

const RFI_MEASUREMENTS_URL = `${serverUrl}/rfi/measurements`

// Imported RFI scan samples; fetched once, the data changes only on a manual import.
export function useRfiMeasurements() {
  const [measurements, setMeasurements] = useState<RfiMeasurement[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const controller = new AbortController()

    const fetchMeasurements = async () => {
      try {
        const response = await fetch(RFI_MEASUREMENTS_URL, { signal: controller.signal })

        if (!response.ok) {
          throw new Error(`RFI measurements request failed with status ${response.status}`)
        }

        setMeasurements((await response.json()) as RfiMeasurement[])
        setError(false)
      } catch (err) {
        if ((err as Error).name === 'AbortError') return
        setMeasurements([])
        setError(true)
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false)
        }
      }
    }

    fetchMeasurements()

    return () => controller.abort()
  }, [])

  return { measurements, isLoading, error }
}
